import { render, staticRenderFns } from "./industry-chain.vue?vue&type=template&id=3f758221&"
import script from "./industry-chain.vue?vue&type=script&lang=js&"
export * from "./industry-chain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports